import type { FC } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { FilterRow } from "web_myplann/NotificationCenter/FilterScreen/FilterRow";
import { DOCUMENTS_TYPE_RESOURCE } from "web_myplann/NotificationCenter/Utils/filterLabels";

interface DocumentsFilterRowProps {
	selected: boolean;
	onClick: () => void;
}

export const DocumentsFilterRow: FC<DocumentsFilterRowProps> = ({
	selected,
	onClick,
}) => {
	const { t } = useResource();

	return (
		<FilterRow
			label={t(DOCUMENTS_TYPE_RESOURCE)}
			selected={selected}
			onClick={onClick}
			isLast
			testId="notification-center-filter-type-documents"
		/>
	);
};
